import { getCache, hasCache, removeCache, setCache } from '@/helpers/persistent-cache';
import { pushRealtimeTrackingHistogram } from '@/services/realtime-tracking/realtime-tracking';

const FIRST_VISIT_FROM_LAND_CACHE_KEY = 'first_visit_from_landing';
const REDIRECT_FROM_LAND_CACHE_KEY = 'redirect_from_land';
const EVENT_NAME = 'first_mma_visit_from_landing';

export function trackFirstVisitFromLanding() {
  const hasVisitedBefore = hasCache(FIRST_VISIT_FROM_LAND_CACHE_KEY);
  if (hasVisitedBefore) return;

  setCache(FIRST_VISIT_FROM_LAND_CACHE_KEY, 'true');

  const redirectFromLandTimestamp = getCache(REDIRECT_FROM_LAND_CACHE_KEY);
  removeCache(REDIRECT_FROM_LAND_CACHE_KEY);

  if (redirectFromLandTimestamp) {
    const ts = Date.parse(redirectFromLandTimestamp);
    if (!isNaN(ts)) {
      const timeDifference = Date.now() - ts;
      pushRealtimeTrackingHistogram(EVENT_NAME, {}, timeDifference, {
        sendOnce: true,
      });
    }
  }
}
